/* eslint-disable no-undef */

import api from '../api'

export const GET_ADVIECES = 'GET_ADVIECES'

export default {
  state: {patientDoctorAdviceChanges: []},
  mutations: {
    [GET_ADVIECES] (state, patientDoctorAdviceChanges) {
      Object.assign(state, patientDoctorAdviceChanges)
    }
  },
  actions: {
    [GET_ADVIECES] ({commit}, user) {
      return new Promise(function (resolve, reject) {
        api.queryDoctorAdvice(user).then((data) => {
          commit(GET_ADVIECES, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/doctorAdvices.js